import React, { useEffect } from 'react';
import { Box, Grid, IconButton, Switch, Typography } from '@mui/material';
import {
  StrategiesDocument,
  Strategy,
  StrategyStatus,
  useUpdateStrategyMutation,
} from '../../../shared/types/generated';
import { useMetaCloudHook } from '../../meta-api-cloud/meta-api-cloud-hooks';
import { MetatraderSymbolPrice } from 'metaapi.cloud-sdk/dist/clients/metaApi/metaApiWebsocket.client';
import { openSnackbarAction } from '../../../shared/components/snackbar/snackbar-actions';
import { TypeMessage } from '../../../shared/components/snackbar/snackbar-types';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { deletePairDialogStoreAction } from '../pair-actions';

type PairItemProps = {
  strategy: Strategy;
  onSuccess?: () => void;
};

export const PairItem: React.FC<PairItemProps> = ({ strategy, onSuccess }) => {

  const { connection } = useMetaCloudHook();

  const [price, setPrice] = React.useState<MetatraderSymbolPrice | undefined>(undefined);
  useEffect(() => {

    if (strategy.symbol && strategy.status === StrategyStatus.Active && connection) {
      setInterval(() => {
        setPrice(connection?.terminalState.price(strategy.symbol as string));

      }, 1000);
    }

  }, [strategy, connection]);

  const [update] = useUpdateStrategyMutation({
    awaitRefetchQueries: true,
    refetchQueries: [StrategiesDocument],
    onCompleted: async (data) => {
      if (data.updateStrategy?.status === StrategyStatus.Active) {
        connection?.subscribeToMarketData(strategy.symbol as string, []);
      } else {
        connection?.unsubscribeFromMarketData(strategy.symbol as string, []);
      }
      openSnackbarAction(
        'Update strategy successfully!',
        TypeMessage.SUCCESS,
      );
      if (onSuccess) onSuccess();
    },
  });


  return (
    <Grid my={'10px'} px={'10px'} container>
      <Grid container py={'5px'} borderBottom={'1px solid #F0F0F0'}>
        <Grid item xs={3}>
          <Typography fontWeight={600}>{strategy.symbol}</Typography>
        </Grid>
        <Grid style={{ color: '#55BE2D' }} item xs={6}>
          <Typography textAlign={'center'}>
            {price ? price?.bid : 0}
          </Typography>
        </Grid>
        <Grid item xs={3} textAlign={'center'}>
          <Box display='flex' alignItems={'center'} justifyContent='center'>
            <Box mr={1}>
              <Switch
                size='medium'
                style={{ color: '#55BE2D' }}
                checked={strategy.status === StrategyStatus.Active}
                onClick={() => {
                  update({
                    variables: {
                      data: {
                        status: strategy.status === StrategyStatus.Active ? StrategyStatus.Inactive : StrategyStatus.Active,
                      },
                      where: {
                        id: strategy.id,
                      },
                    },
                  });
                }
                }
              />
            </Box>
            <Box>
              <IconButton onClick={() => deletePairDialogStoreAction({ open: true, pair: strategy })}>
                <DeleteOutlineIcon sx={{ fontSize: 30 }} />
              </IconButton>
            </Box>
          </Box>

        </Grid>
      </Grid>
    </Grid>
  );
};
